import React from 'react';
import ModularDashboard from './SEODashboard/index';

/**
 * SEO Dashboard
 * 
 * Main dashboard for SEO data visualization and management.
 * Implementation is modularized in subdirectory for better organization.
 */

const SEODashboard = () => {
  return <ModularDashboard />;
};

export default SEODashboard;